export const USER_FORM_TAB_LABELS = {
  basic: 'Perfil',
  permissions: 'Segurança',
  settings: 'Configurações',
  customers: 'Customers',
  email: 'Email',
};

const FIELD_META = {
  username: { tab: 'basic', fieldLabel: 'Nome' },
  user: { tab: 'basic', fieldLabel: 'E-mail' },
  password: { tab: 'permissions', fieldLabel: 'Senha' },
  type: { tab: 'permissions', fieldLabel: 'Tipo de usuário' },
  os_types: { tab: 'permissions', fieldLabel: 'Tipos de OS' },
  asstec_openos_type_only: { tab: 'permissions', fieldLabel: 'Abrir OS só dos Tipos selecionados' },
  reembolso_perms: { tab: 'permissions', fieldLabel: 'Gestão de reembolsos' },
  codtec: { tab: 'permissions', fieldLabel: 'Código do técnico' },
};

export function listUserFormTabErrors(errors) {
  if (!errors || typeof errors !== 'object') return [];
  return Object.entries(errors)
    .filter(([, message]) => message)
    .map(([key, message]) => {
      const meta = FIELD_META[key] || { tab: 'basic', fieldLabel: key };
      return {
        key,
        message: String(message),
        tab: meta.tab,
        tabLabel: USER_FORM_TAB_LABELS[meta.tab] || meta.tab,
        fieldLabel: meta.fieldLabel,
      };
    });
}

export function userFormTabHasError(errors, tabId) {
  return listUserFormTabErrors(errors).some((item) => item.tab === tabId);
}
